class CountdownTimer {
  constructor(el) {
    this.el = el;
    this.type = el.dataset.timerType || 'fixed';
    this.intervalId = null;

    if (this.type === 'fixed') {
      this.endTime = this._parseEndDatetime(el.dataset.endDatetime);
      if (!this.endTime) return;
    } else {
      this.targetTime = el.dataset.repeatTargetTime || '13:00';
    }

    const numSelector = '.countdown-timer__number, .announcement-countdown__number';
    this.daysEl = el.querySelector('[data-countdown-days] :is(' + numSelector + ')');
    this.hoursEl = el.querySelector('[data-countdown-hours] :is(' + numSelector + ')');
    this.minutesEl = el.querySelector('[data-countdown-minutes] :is(' + numSelector + ')');
    this.secondsEl = el.querySelector('[data-countdown-seconds] :is(' + numSelector + ')');

    this._tick();
    this.intervalId = setInterval(() => this._tick(), 1000);
  }

  _parseEndDatetime(str) {
    if (!str) return null;
    const date = new Date(str);
    return isNaN(date.getTime()) ? null : date;
  }

  _getNextTargetDate() {
    const [hours, minutes] = this.targetTime.split(':').map(Number);
    const now = new Date();
    const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);

    if (target.getTime() <= now.getTime()) {
      target.setDate(target.getDate() + 1);
    }

    return target;
  }

  _tick() {
    if (this.type === 'fixed') {
      this._tickFixed();
    } else {
      this._tickRepeating();
    }
  }

  _tickFixed() {
    const now = Date.now();
    const diff = Math.max(0, Math.floor((this.endTime.getTime() - now) / 1000));

    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    this._render(days, hours, minutes, seconds);

    if (diff <= 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  _tickRepeating() {
    const now = Date.now();
    const target = this._getNextTargetDate();
    const diff = Math.max(0, Math.floor((target.getTime() - now) / 1000));

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    this._render(null, hours, minutes, seconds);
  }

  _render(days, hours, minutes, seconds) {
    if (this.daysEl && days !== null) {
      this.daysEl.textContent = String(days).padStart(2, '0');
    }
    if (this.hoursEl) {
      this.hoursEl.textContent = String(hours).padStart(2, '0');
    }
    if (this.minutesEl) {
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
    }
    if (this.secondsEl) {
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-countdown-block]').forEach((el) => {
    new CountdownTimer(el);
  });
});
